import { render } from "./Post.vue?vue&type=template&id=0a96a728"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=0a96a728&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__